(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-reviews"] && !Shopify.designMode) return;
  try {
    
  class PaReviewsTrack extends HTMLElement {
    connectedCallback() {
      // Desktop slider starts centered on the middle card so partial cards
      // peek on BOTH sides (infinite-strip look). Grid mode and mobile keep
      // their natural start position.
      if (this.classList.contains('pa-reviews__track--grid')) return;
      if (!window.matchMedia('(min-width: 750px)').matches) return;

      requestAnimationFrame(() => {
        const cards = this.children;
        if (cards.length < 2) return;
        const mid = cards[Math.floor(cards.length / 2)];
        if (!mid) return;
        const left = mid.offsetLeft - (this.clientWidth - mid.clientWidth) / 2;
        this.scrollLeft = Math.max(0, left);
      });
    }
  }

  if (!customElements.get('pa-reviews-track')) {
    customElements.define('pa-reviews-track', PaReviewsTrack);
  }

  } catch(e) { console.error(e); }
})();
})();
